{
    "Profile_SideBar.policies": "FR: Policies",
    "Profile_SideBar.summary": "FR: Summary",
    "Profile_SideBar.terms": "FR: Terms",
    "Profile_SideBar.underwriterCoverageAdjustment": "FR: Underwriting",
    "Profile_SideBar.policy": "FR: Policy",
    "Profile_SideBar.applicant": "FR: Insured",
    "Profile_SideBar.insuranceApplicant": "FR: Insurance Applicant",
    "Profile_SideBar.securemyoffer.secureMyOffer": "FR: Secure My Offer",
    "Profile_SideBar.securemyoffer.insuranceApplicant": "FR: Insurance Applicant",
    "Profile_SideBar.payment": "FR: Payment",
    "Profile_SideBar.documents": "FR: Documents",
    "Profile_SideBar.notes": "FR: Notes",
    "Profile_SideBar.history": "FR: History",
    "Profile_SideBar.logs": "FR: API Logs",
    "Profile_SideBar.securemyoffer.additionalSellers": "Vendeurs additionnels"
}
